import { LAYOUT } from '@admin/router/constant'

// Ads Facebook Router
const AdsFbRouter = {
  path: '/ads',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/ads/fb/material',
      name: 'AdsFbMaterialList',
      component: () => import('@admin/views/ads/facebook/material/index.vue'),
      meta: {
        title: '素材管理',
      },
    },
    {
      path: '/ads/fb/account',
      name: 'AdsFbAccount',
      component: () => import('@admin/views/ads/facebook/account/index.vue'),
      meta: {
        title: 'Facebook广告帐号',
      },
    },
    {
      path: '/ads/fb/adlist',
      name: 'AdsFbAdList',
      component: () => import('@admin/views/ads/facebook/adlist/index.vue'),
      meta: {
        title: 'Facebook广告',
      },
    },
    {
      path: '/ads/fb/edit',
      name: 'AdsFbAdEdit',
      component: () => import('@admin/views/ads/facebook/edit/index.vue'),
      meta: {
        title: '编辑Facebook广告',
      },
    },
    {
      path: '/ads/fb/create',
      name: 'AdsFbAdCreate',
      component: () => import('@admin/views/ads/facebook/create/index.vue'),
      meta: {
        title: '创建Facebook广告',
      },
    },
    {
      path: '/ads/fb/preview',
      name: 'AdsFbAdPreview',
      component: () => import('@admin/views/ads/facebook/preview/index.vue'),
      meta: {
        title: 'FB广告预览&同步',
      },
    },
    {
      path: '/ads/fb/config',
      name: 'AdsFbConfig',
      component: () => import('@admin/views/ads/facebook/config/index.vue'),
      meta: {
        title: 'FB广告字段参数配置',
      },
    },
  ],
}

export default AdsFbRouter
